import { ItemListElements } from "next-seo/lib/jsonld/breadcrumb";

export const useBreadcrumb = (
  breadcrumbs: Omit<ItemListElements, "position">[]
): ItemListElements[] => {
  const itemListElements = breadcrumbs.map((breadcrumb, index) => ({
    position: index + 2,
    ...breadcrumb,
  }));

  return [
    {
      position: 1,
      name: "チャット占い・電話占い",
      item: "/",
    },
    ...itemListElements,
  ];
};
